<template lang="pug">
  b-container
    b-form-row.align-items-center.mt-3.mb-4
      b-col
        h4.mb-0 Feedback
    b-form-row.align-items-end.mb-3(no-gutters)
      b-col
        b-form-group
          b-input-group
            b-form-input(placeholder="Buscar...", type="search", v-model="search")
            b-input-group-append
              b-input-group-text
                search-icon.icon-md
      b-col(cols="auto")
        b-dropdown(right, variant="light")
          template(slot="button-content")
            filter-icon.icon-sm
            span.ml-1(v-if="$breakpoint.mdUp") Filtros
          b-dropdown-header Contestados
          b-dropdown-form
            b-form-checkbox.text-nowrap(v-model="filters.answered", @change="") Mostrar contestados
          b-dropdown-header Tipo de encuesta
          b-dropdown-form
            b-form-select(v-model="filters.type",  size="sm", @change="filters.scale = null")
              template(slot="first")
                option(:value="null", disabled) -- Selecciona tipo --
              option(v-for="type in question_types", :key="type.value", :value="type.value") {{type.title}}
          div(v-if="filters.type === 'csat'")
            b-dropdown-header Tipo de escala
            b-dropdown-form
              b-form-select(v-model="filters.scale",  size="sm")
                template(slot="first")
                  option(:value="null", disabled) -- Selecciona escala --
                option(v-for="type in scale_types", :key="type.value", :value="type.value") {{type.title}}
    b-list-group.mb-3
      b-list-group-item(v-for="feedback in feedbacks", :key="feedback.feedback_id")
        p {{ feedback.question }}
        p {{ feedback.score || "0" }}
        p {{ feedback.additional_comment }}
    empty-message(message="Aún no hay retroalimentación", v-if="!feedbacks.length")
    .d-flex.align-items-center
      b-pagination.mb-0(:total-rows="v_paginationItemsCount", :per-page="v_paginationLimit", :value="paginationCurrentPage", @change="paginationPageChanged($event, 'getFeedback')", v-if="v_paginationShow")
      b-spinner.ml-3(small, variant="primary", v-if="loading")
</template>

<script>
import debounce from 'lodash.debounce'
import { createNamespacedHelpers, mapActions } from 'vuex'
const feedbackController = createNamespacedHelpers('feedback')

export default {
  data () {
    return {
      loading: false,
      search: "",
      filters: {
        answered: true,
        type: null,
        scale: null,
      },
      question_types: [
        {value: 'csat', title: 'Customer Satisfaction Score (indicador de satisfacción del cliente)'},
        {value: 'nps', title: 'Net Promoter Score (lealtad del cliente)'},
        {value: 'ces', title: 'Customer Effort Score (nivel de facilidad de la experiencia)'},
      ],
      scale_types: [
        {value: 'one_to_five', title: 'De 1 a 5'},
        {value: 'five_stars', title: '5 estrellas'},
        {value: 'five_emojis', title: '5 emojis'},
      ]
    }
  },
  computed: {
   ...feedbackController.mapState({
     feedbacks: state => state.feedbacks
   }),
  },
  methods: {
    ...mapActions(["feedback/all"]),
    getFeedback () {
      this.loading = true
      let self = this
      this.showLoadingScreen()

      this['feedback/all']({
        account_id: self.$route.params.account_id,
        params: {
          ...self.paginationParamsObject,
          ...self.filters,
          question: self.search,
        },
        callback: res => {
          self.hideLoadingScreen()
          this.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.parsePaginationDataFromResponse(res)
          }
        }
      });
    },
    filterFeedback: debounce(function (){
      this.resetPaginationData()
      this.getFeedback()
    })
  },
  mounted () {
    this.getFeedback()
  },
  watch: {
    filters: {
      handler: function () {
        this.filterFeedback()
      },
      deep: true
    },
    search () {
      this.filterFeedback()
    }
  },
}
</script>

<style lang="scss" scoped>
</style>
